import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Crest } from "@/components/Crest";
import { ShieldCheck } from "lucide-react";

const STAFF_ROLES = ["founder", "super_admin", "rectorate", "admissions", "assessment_reviewer",
  "academic_admin", "faculty", "marketing", "content_editor", "translator", "finance",
  "scholarships", "investor_relations", "student_services", "support", "legal", "data_protection"];

// Distinct institutional entrance for faculty / administration. Staff never
// self-register: accounts are created by an administrator and activated by email.
export default function StaffLogin() {
  const { login, logout } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const u = await login(email, password);
      if (!STAFF_ROLES.includes(u.role)) {
        logout();
        setError("This entrance is for SIMO staff only. Families and students should use the family login.");
        return;
      }
      nav("/admin");
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0b0f] p-8">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="staff-login">
        <Link to="/" className="flex items-center gap-3 mb-8"><Crest className="h-10 w-10" /><span className="font-serif text-2xl text-paper">Simo · Staff</span></Link>
        <div className="flex items-center gap-2 text-heraldic mb-2"><ShieldCheck className="h-5 w-5" /><span className="text-xs uppercase tracking-widest">Institutional access</span></div>
        <h1 className="font-serif text-4xl text-paper">Staff login</h1>
        <p className="mt-2 text-paper/50 text-sm">Faculty & administration only.</p>
        {error && <div data-testid="staff-login-error" className="mt-4 text-sm text-red-400">{error}</div>}
        <div className="mt-6 space-y-3">
          <input data-testid="staff-login-email" type="email" required placeholder="Staff email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-sm px-3 py-3 text-sm text-paper placeholder:text-paper/30" />
          <input data-testid="staff-login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-sm px-3 py-3 text-sm text-paper placeholder:text-paper/30" />
        </div>
        <button data-testid="staff-login-submit" className="mt-6 w-full bg-heraldic text-white py-3 rounded-sm">Log in</button>
        <p className="mt-4 text-xs text-paper/40">No account yet? Staff accounts are created by an administrator — you'll receive an activation email. <Link to="/login" className="text-heraldic">Family login →</Link></p>
      </form>
    </div>
  );
}
